import { createContext, useCallback, useContext, useEffect, useMemo, useState } from 'react';
import api from '@/lib/api';

// Sensible fallbacks used before the first /settings response arrives so we
// never show a "store closed" banner during the initial paint.
const DEFAULTS = {
  site_name: 'Jwalek',
  site_description: 'Jwalek — Design it your way, we print it perfectly.',
  site_url: 'https://jwalek.com',
  contact_email: 'hello@jwalek.com',
  contact_phone: '+966 11 000 0000',
  business_address: 'Riyadh, Kingdom of Saudi Arabia',
  footer_tagline: 'Design it your way, we print it perfectly.',
  social_instagram: '#',
  social_twitter: '#',
  store_open: true,
  store_closed_message: '',
  store_closed_message_ar: '',
};

const SiteSettingsContext = createContext(null);

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(DEFAULTS);
  const [loaded, setLoaded] = useState(false);

  const refresh = useCallback(async () => {
    try {
      const { data } = await api.get('/settings');
      setSettings({ ...DEFAULTS, ...data });
    } finally {
      setLoaded(true);
    }
  }, []);

  useEffect(() => { refresh(); }, [refresh]);

  const value = useMemo(() => ({ settings, loaded, refresh }), [settings, loaded, refresh]);
  return <SiteSettingsContext.Provider value={value}>{children}</SiteSettingsContext.Provider>;
}

export const useSiteSettings = () => useContext(SiteSettingsContext) || { settings: DEFAULTS, loaded: false, refresh: () => {} };
